/**
 * Content body for a group therapist block: time, group title and the
 * participant list (first N names, remainder collapsed into "+N weitere").
 */
import React from "react";
import { MCEventContentProps, MetaRow, SublocalityStrip, TimeRange } from "./parts";

const MAX_PARTICIPANT_LINES = 3;

const GroupContent: React.FC<MCEventContentProps> = ({ event }) => {
  const names = event.participantNames ?? [];
  const hidden = Math.max(names.length - MAX_PARTICIPANT_LINES, 0);
  return (
    <>
      <TimeRange event={event} />
      <span className="mc-event-title">{event.title || event.patientLabel}</span>
      {names.length > 0 && (
        <span className="mc-event-participants">
          {names.slice(0, MAX_PARTICIPANT_LINES).map((name, i) => (
            <span key={i} className="mc-event-participant">
              {name}
            </span>
          ))}
          {hidden > 0 && (
            <span
              className="mc-event-participant is-more"
              title={names.slice(MAX_PARTICIPANT_LINES).join("\n")}
            >
              +{hidden} weitere
            </span>
          )}
        </span>
      )}
      <MetaRow event={event} />
      <SublocalityStrip event={event} full={false} />
    </>
  );
};

export default GroupContent;
